import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const district = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("districts"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("districts/" + id));
    return data;
  },
  store: async (
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    colors,
    sizes,
    imageUrl
  ) => {
    const { data } = await axios.post(h.baseUrl("districts"), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      colors,
      sizes,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl
  ) => {
    const { data } = await axios.put(h.baseUrl("districts/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("districts/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default district;
